import { each } from 'lodash';
import { runBasePreload } from '../../common/logic/generalPreload';

const runPreload = (data, concepts, fields, dispatchChangeLoadingState) => {
  runBasePreload(data, dispatchChangeLoadingState, (baseSrcList) => {
    if (!!concepts && !!concepts.length) {
      each(concepts, (concept) => {
        each(fields, (field) => {
          if (concept[field]) {
            baseSrcList.push({
              src: concept[field],
              callback: (img) => { concept[`${field}_object`] = img; }
            });
          }
        });
      });
    }
  });
};

export default runPreload;
